import { USER_ROLES } from '~/constants/auth'

export default defineNuxtRouteMiddleware((to) => {
  const token = useCookie('token')
  const authStore = useAuthStore()
  const { logout } = useSuccessfulLogout()
  const localePath = useLocalePath()

  if (
    token.value &&
    authStore.user?.role === USER_ROLES.LEAD &&
    (!authStore.user?.phone || !authStore.user?.firstName) &&
    !to.name?.toString().startsWith('signup-contact')
  ) {
    return navigateTo(localePath('/signup/contact'))
  }

  if (!token.value || !authStore.user) {
    const currentPath = to.fullPath
    return navigateTo(localePath(`/login?redirect=${encodeURIComponent(currentPath)}`))
  }
})
